import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'user',
  standalone: false,
})
export class UserPipe implements PipeTransform {
  private prefix: string = '';

  constructor(private translateService: TranslateService) {
    this.prefix = translateService.instant('user.phone.number.extension.short');
  }

  transform(value: { extension: string; lastName: string; firstName?: string }): any {
    return `${this.prefix} ${value.extension} | <b>${value.lastName}${
      value.firstName ? ` ${value.firstName}` : ''
    }</b>`;
  }
}
